<template>
  <el-form ref="form" :model="news" label-width="90px">
    <el-form-item
      label="Date"
      class="max-w-md"
      prop="date"
      :rules="[
        {
          required: true,
          message: 'A date is required'
        }
      ]"
    >
      <el-date-picker
        v-model="news.date"
        type="date"
        value-format="yyyy-MM-dd"
        :default-value="today"
      />
    </el-form-item>
    <el-form-item label="Thumb" prop="thumb">
      <div class="inline-block relative">
        <dropzone-image
          v-model="news.thumb"
          :path="'news'"
          :model-prop="'thumb'"
        />
        <div class="absolute top-0 right-0 m-2 flex flex-col z-20">
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="mini"
            @click="deleteThumb"
          />
        </div>
      </div>
    </el-form-item>
    <el-form-item label="Text" prop="text" class="max-w-6xl">
      <el-input v-model="news.text" />
      <markdown-helper />
    </el-form-item>
    <el-form-item label="Fake News" class="max-w-sm" prop="fake">
      <el-checkbox v-model="news.fake" />
    </el-form-item>
    <el-divider />
    <el-row>
      <el-button type="success" @click="save"
        ><i class="el-icon-check" /> {{ saveText }}</el-button
      >
      <el-button type="danger" @click="$emit('delete')"
        ><i class="el-icon-delete" /> {{ deleteText }}</el-button
      >
    </el-row>
  </el-form>
</template>

<script>
import Vue from 'vue'
import MarkdownHelper from '@/admin/components/MarkdownHelper.vue'
import DropzoneImage from '@/admin/components/DropzoneImage.vue'

export default {
  name: 'AdminNewsForm',

  components: {
    MarkdownHelper,
    DropzoneImage
  },

  props: {
    news: {
      default: () => {},
      type: Object
    },

    saveText: {
      default: 'Save',
      type: String
    },

    deleteText: {
      default: 'Delete',
      type: String
    }
  },

  data() {
    return {
      today: new Date()
    }
  },

  methods: {
    deleteThumb() {
      Vue.set(this.news, 'thumb', null)
    },

    validate() {
      let valid
      this.$refs.form.validate(v => {
        valid = v
      })
      return valid
    },

    save() {
      const valid = this.validate()
      if (valid) {
        this.$emit('save')
      }
    }
  }
}
</script>
